/*
 * @Description: 选择地址
 * @Author: maowy
 * @Date: 2020-10-21 14:33:31
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: yyyy-08-Th 10:26:01
*/

import Vue from 'vue'
// import _ from 'lodash'
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import {
    setLocalConfig,
    getLocalConfig
} from '@/utils/storage.js'
import {
    getHotCityList,
    // selectAddress
} from '@/models/selectAddress'
import { Loading } from 'vant'
import selectAddressSearch from './selectAddressSearch/selectAddressSearch'

Vue.use(Loading)

export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.selectAddress,
    components: {
        selectAddressSearch
    },
    data () {
        return {
            longitude: '',
            latitude: '',
            addressInfo: {
                city: ''
            }, // 根据经纬度逆向编码获得详细地址
            hotCityList: [], // 热门城市列表
        }
    },
    computed: {
        ...mapState({
        }),
    },
    watch: {
        '$route' (to, from) {
        }
    },
    created () {
        this.$emit('setHeader', {
            title: '选择地址',
            showHeader: true,
            showLeft: true
        })
        this.setAppClass({
            isAppend: false,
            className: 'fcWhite'
        })
    },
    activated () {
    },
    async mounted () {
        this.addressInfo = getLocalConfig('AddressInfo')
        this.addressInfo['city'] = this.$route.query.city || this.addressInfo['city'] || '广州'
        this.getHotCityData()
    },
    methods: {
        ...mapActions([
            'setAppClass',
            'getLocation',
            'getAddress',
            'saveAddressInfo',
        ]),
        getHotCityData () {
            this.showLoading()
            getHotCityList({
            }).then(res => {
                this.hideLoading()
                this.hotCityList = res.list
            }).catch(() => {
                this.hideLoading()
            })
        },
        getMyLocation () {
            let that = this
            that.showLoading()
            const options = { timeout: 3000, from: 'noTips' }
            this.getLocation(options).then(this.showPosition).catch(this.showErr).finally(() => {
                this.hideLoading()
            })
        },
        /* 获取位置信息成功 */
        showPosition (position) {
            this.longitude = position.lng
            this.latitude = position.lat
            this.getAddressData()
        },
        /* 获取位置信息失败，定位失败再请求定位，测试使用 */
        showErr () {
            // 定位同和地铁站
            this.hideLoading()
            this.longitude = 113.332926
            this.latitude = 23.202723
            this.setAddressInfo({
                longitude: 113.332926,
                latitude: 23.202723,
                address: '广州-同和地铁站'
            }, false)
        },
        getAddressData () {
            // 经纬度数组
            let lnglatArr = []
            lnglatArr.push(this.longitude, this.latitude)
            this.getAddress(lnglatArr)
                .then((res) => {
                    let param = {
                        longitude: this.longitude,
                        latitude: this.latitude,
                        province: res.addressComponents.province,
                        city: res.addressComponents.city,
                        district: res.addressComponents.district,
                        name: res.address || '',
                        formattedAddress: res.address
                    }
                    this.saveAddressInfo(param)
                    setLocalConfig('isChangePosition', '1')
                    this.addressInfo = getLocalConfig('AddressInfo')
                }).catch(() => {
                })
        },
        setAddressInfo (params, successStatus = true) {
            const obj = {
                longitude: params.longitude,
                latitude: params.latitude,
                province: '广东省',
                city: '广州市',
                district: '白云区',
                name: '广州-同和地铁站',
                formattedAddress: '广州-同和地铁站'
            }
            if (!successStatus) {
                this.address = '广州-同和地铁站'
            } else {
                Object.assign(obj, params)
            }
            this.saveAddressInfo(obj)
            setLocalConfig('isChangePosition', '1')
            this.addressInfo = getLocalConfig('AddressInfo')
        },
        // 选择城市
        setCity (city) {
            this.addressInfo['city'] = city
        },
        // undate城市
        updateAddress () {
            setLocalConfig('isChangePosition', '1')
            this.addressInfo = getLocalConfig('AddressInfo')
            this.$router.go(-1)
        }
    },

    destroyed () {
    },
}
